// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'rocket-solid';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path
      fill='currentColor'
      d='m16.438 1.61-1.53.17a5.313 5.313 0 0 0-3.169 1.523L4.792 10.25l3.004 3.005 6.948-6.947a5.308 5.308 0 0 0 1.523-3.17zM5.19 7.108 2.735 9.563c-.322-.107-1.019-.482-1.035-.55-.016-.069.299-.477.483-.661a4.253 4.253 0 0 1 2.03-1.132c.322-.076.65-.112.977-.112zm5.748 5.825a4.25 4.25 0 0 1-1.242 2.93c-.143.142-.496.393-.596.387s-.501-.587-.599-.88z'
    />
    <path d='M6.01 13.631a1.589 1.589 0 0 1-.467 1.127c-.622.622-3.754 1.502-3.754 1.502s.88-3.134 1.503-3.754a1.591 1.591 0 0 1 1.022-.464' />
  </g>
);

export const viewBox = '0 0 18 18';
